import { useSnapshot } from "valtio";
import { state } from "../../../context/store";
import { Button, Text, Column, Row, Grid } from '../../Blocks';
import { ColorSwatchContainer, NumberPad } from '../index';
import { closePopups, resetRaceNumber } from "../../../utilities";



const ModalNumber = () => {
  const snap = useSnapshot(state.current);

  const initialReset = () => {
    state.current.status.confirmRemoveNumber = true
  };


  const selectNumber = () => {
    state.current.status.numberSelectMode = "number"
  };
  const selectColor = () => {
    state.current.status.numberSelectMode = "color"
  };
  const selectOutline = () => {
    state.current.status.numberSelectMode = "outline"
  };

  return (

    <Column id="number-choices" dataId="number-choices" gap="12px">


      {/* Messages and Feedback  */}


      {/* <Column gap="6px" minh="20ch">
        {snap.status.numberSelectMode === "number" && <Text color="var(--heading-color-2)" width="28ch" size="14px">{snap.status.numberSelectMode === "number" ? "Enter up to three digits for your race number" : "Select your race number color"}
        
        */}

      {/* </Text> */}



      {snap.status.numberSelectMode === "number" ?
        <NumberPad />
        :
        null
      }
      {snap.status.numberSelectMode === "color" ?

        <ColorSwatchContainer limit="numbers" section="raceNumber" texture={false} /> : null
      }
      {snap.status.numberSelectMode === "outline" ?

        <ColorSwatchContainer limit="numbers" section="raceNumber" texture={false} />

        : null
      }

      {/* Messages and Feedback  */}

      <Column gap="0px" minh="6ch" justify="start">
        {snap.status.numberSelectMode === "number" && <Text color="var(--heading-color-2)" width="28ch" size="15px">Enter up to three digits</Text>}
        {/* {snap.status.numberSelectMode === "number" && <Text color="var(--heading-color-2)" width="28ch" size="15px">Enter up to three digits for your <strong>race number</strong></Text>} */}
        {snap.status.numberSelectMode === "number" && <Text color="var(--heading-color-2)" size="17px"> <strong>{snap.choices.raceNumber.selected.number}</strong> </Text>}

        {snap.status.numberSelectMode === "color" && <Text color="var(--heading-color-2)" size="15px">Pick your <strong>number color</strong> </Text>}
        {snap.status.numberSelectMode === "color" && <Text color="var(--heading-color-2)" size="17px"> {snap.choices.raceNumber.selected.name} Numbers </Text>}

        {snap.status.numberSelectMode === "outline" && <Text color="var(--heading-color-2)" size="15px">Pick your <strong>outline</strong> color</Text>}
        {snap.status.numberSelectMode === "outline" && <Text color="var(--heading-color-2)" size="17px">{snap.choices.raceNumber.selected.outlineName} Outline </Text>}

      </Column>

      {/* Buttons for changing number, color, outline, and confirming removal  */}

      <Grid cols="1fr 1fr" rows="1fr 1fr" gap="10px">

        {snap.status.numberSelectMode !== "number" ? (
          <Button fullWidth mobileText="Number" handleClick={selectNumber}>

            Change Number
          </Button>
        ) : null}
        {snap.status.numberSelectMode !== "color" ? (
          <Button fullWidth mobileText="Color" handleClick={selectColor}>

            Number Color
          </Button>
        ) : null}
        {snap.status.numberSelectMode !== "outline" ? (
          <Button fullWidth mobileText="Color" handleClick={selectOutline}>

            Outline Color
          </Button>
        ) : null}



        <Button fullWidth mobileText="Remove Number" accent={snap.status.confirmRemoveNumber === true} handleClick={snap.status.confirmRemoveNumber === true ? resetRaceNumber : snap.status.numberSelectMode === "color" ? selectNumber : initialReset}>
          {snap.status.confirmRemoveNumber ? "Confirm Removal" : "Remove Number"}

        </Button>

        <Button fullWidth handleClick={(e) => closePopups(e)}>
          Confirm
        </Button>
      </Grid>
    </Column >

  );
};

export default ModalNumber;